// extracted by mini-css-extract-plugin
export default {"footerWrapper":"footer_footerWrapper__jPaYu"};